// Avatar.tsx — l'immagine di un avatar (v019; v021: immagini senza cerchio, il cerchio dietro è del colore primario).
// Gli avatar sono in web/public/avatar/ (256 px) e web/public/avatar/grande/ (768 px), vedi condiviso/avatar.ts.
import type { CSSProperties } from "react";
import { fileAvatar, fileSpeciale } from "../../../condiviso/avatar.ts";

export type Quale = number | "bot" | "mistero" | null | undefined;

/** Da questa dimensione (px CSS) in su si usa l'immagine grande: su un telefono a 2–3× la piccola si vedrebbe morbida. */
const SOGLIA_GRANDE = 110;

export function srcAvatar(q: Quale, dimensione = 48): string {
  const grande = dimensione >= SOGLIA_GRANDE;
  return q === "bot" || q === "mistero" ? fileSpeciale(q, grande) : fileAvatar(q, grande);
}

/**
 * Avatar: il personaggio davanti a un cerchio del colore primario (il cappello può uscire dal cerchio). `anello` aggiunge
 * il bordo chiaro con l'alone. Il «mistero» ha già il suo cerchio. Decorativo se `alt` è vuoto.
 */
export function Avatar({ quale, dimensione = 48, anello = false, alt = "", classe = "" }: { quale: Quale; dimensione?: number; anello?: boolean; alt?: string; classe?: string }) {
  const stile = { "--ld-av": `${dimensione}px` } as CSSProperties;
  return (
    <span className={`ld-avatar${anello ? " ld-avatar-anello" : ""} ${classe}`} style={stile}>
      {quale !== "mistero" && <span className="ld-avatar-cerchio" aria-hidden="true" />}
      <img className="ld-avatar-img" src={srcAvatar(quale, dimensione)} width={dimensione} height={dimensione} alt={alt} decoding="async" draggable={false} />
    </span>
  );
}
